import {
  CLEAR_PAYROLL_SHEET,
  GET_ADVANCE,
  GET_ADVANCE_SUMMARY,
  CREATE_EMPLOYEE,
  DELETE_EMPLOYEE,
  EDIT_EMPLOYEE,
  GET_ATTENDANCE,
  GET_EMPLOYEE,
  GET_MONTH_ATTENDANCE,
  SET_PAYROLL_SHEET,
} from '../constant/constant';

export const EmployeeReducer = function (state = [], action) {
  switch (action.type) {
    case GET_EMPLOYEE: {
      return [...action.payload];
    }
    case CREATE_EMPLOYEE: {
      return [...state, action.payload];
    }
    case EDIT_EMPLOYEE: {
      return state.map((emp) =>
        emp._id === action.payload._id ? { ...emp, ...action.payload } : emp
      );
    }
    case DELETE_EMPLOYEE: {
      return state.filter(({ _id }) => _id !== action.payload?._id);
    }
    default: {
      return state;
    }
  }
};

export const AttendanceReducer = function (state = [], action) {
  switch (action.type) {
    case GET_ATTENDANCE: {
      return [...action.payload];
    }
    default: {
      return state;
    }
  }
};

export const MonthAttendanceReducer = function (state = [], action) {
  switch (action.type) {
    case GET_MONTH_ATTENDANCE: {
      return [...action.payload];
    }
    default: {
      return state;
    }
  }
};

export const AdvanceReducer = function (state = [], action) {
  switch (action.type) {
    case GET_ADVANCE: {
      return [...action.payload];
    }
    default: {
      return state;
    }
  }
};

export const AdvanceSummaryReducer = function (state = [], action) {
  switch (action.type) {
    case GET_ADVANCE_SUMMARY: {
      return [...action.payload];
    }
    default: {
      return state;
    }
  }
};

const emptySheet = { month: '', monthdays: 0, basis: 'month', rows: [] };

export const PayrollSheetReducer = function (state = emptySheet, action) {
  switch (action.type) {
    case SET_PAYROLL_SHEET: {
      return { ...emptySheet, ...action.payload };
    }
    case CLEAR_PAYROLL_SHEET: {
      return emptySheet;
    }
    default: {
      return state;
    }
  }
};
